import axios from "axios";
import { connect } from "react-redux";
import React, { useState, useRef, useEffect } from "react";
import EventLabel2, { init } from "../../../components/EventLabel2/EventLabel2";
import { eventLabelGroupsConstants } from "../../constants/eventLabelGroups.contansts";
import { Button, List, ListItem, ListItemAvatar, ListItemText, Tooltip } from "@material-ui/core";
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";
import ClearIcon from "@material-ui/icons/Clear";
import InsertCommentIcon from "@material-ui/icons/InsertComment";
import GavelIcon from "@material-ui/icons/Gavel";
import { combineProps } from "../../../helpers/objectHelper";
import { ChatAvatar } from "../ChatModule/components/ChatAvatar";
import PersonRoundedIcon from "@material-ui/icons/PersonRounded";

const SpeakerControl = (props) => {
  const [agenda, setAgenda] = useState([]);
  const [speakers, setSpeakers] = useState([]);
  const [activeSpeaker, setActiveSpeaker] = useState(null);
  const [floorIsGive, setFloorIsGiven] = useState(false);
  const { eventId, clientKey, lang, connected, hubConnection, noneAllowedSpeakers, personTypes, template, clientName, preview, settings } = props;

  const { requestedEventId, getAgendaFromOtherEvent, allowRequestTheFloor, allowPointOfOrder, allowRequestLineOfSpeaker } = settings;

  useEffect(() => {
    init(eventId, eventLabelGroupsConstants.SPEAKER_CONTROL_LABEL_GROUP, lang);
    fetchSpeakers();
    fetchAgenda();
    configureHubEvents();
  }, []);

  const fetchAgenda = () => {
    axios
      .get(`./api/meeting/agenda/${getAgendaFromOtherEvent && requestedEventId ? requestedEventId : eventId}`)
      .then(({ data }) => {
        if (!data) return;
        const agendaItems = data.sort(function (a, b) {
          return a.sortOrder - b.sortOrder;
        });
        setAgenda(agendaItems);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const configureHubEvents = () => {
    if (hubConnection) {
      hubConnection.on("onSpeakersUpdate", (speakers) => setSpeakers(speakers));
      hubConnection.on("onActivateSpeaker", (activeSpeaker) => {
        setActiveSpeaker(activeSpeaker);
      });
      hubConnection.on("onDeactivateSpeaker", () => setActiveSpeaker(null));
      hubConnection.on("onAgendaUpdate", (agenda) => {
        setAgenda(agenda);
      });
      hubConnection.on("onAgendaClosed", (speakers) => {
        setSpeakers(speakers);
        setActiveSpeaker(null);
      });
    }
  };

  const fetchSpeakers = () => {
    axios
      .get(`./api/meeting/speakers/${eventId}`)
      .then(({ data }) => {
        if (data) {
          setSpeakers(data);
          const active = data.find((a) => a.active == true);
          if (active) {
            const speaker = props.orderList.find((ol) => ol.badgeNo == active.badgeNo);
            setActiveSpeaker(speaker);
          }
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const unassignRequest = (agendaItemId, parentId = null) => {
    if (!connected || !hubConnection || (hubConnection.connectionState != 1 && !preview)) return;
    const activeAgenda = agenda.find((a) => a.active == true);
    if (!activeAgenda) return;
    hubConnection
      .invoke("removeSpeaker", {
        eventId,
        agendaItemId: activeAgenda.agendaItemId,
        clientKey,
        parentId,
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const requestTheFloor = (speakerType, parentId = null) => {
    if (!connected || !hubConnection || (hubConnection.connectionState != 1 && !preview)) return;
    const activeAgenda = agenda.find((a) => a.active == true);
    if (!activeAgenda) return;
    hubConnection
      .invoke("setSpeaker", {
        eventId,
        agendaItemId: activeAgenda.agendaItemId,
        clientKey,
        parentId,
        speakerType,
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const hasRequestedTheFloor = (agendaId, parentId = null) => {
    const activeAgenda = agenda.find((a) => a.active == true);
    if (!activeAgenda) return false;
    const hasRequested = speakers.find((s) => s.agendaItemId === activeAgenda.agendaItemId && s.badgeNo === clientKey && /* s.parentInteractionSpeakerId === parentId &&  */ s.closedDateTime === null);
    return hasRequested;
  };

  const isAuthorizedSpeaker = () => {
    if (!clientName || clientName.includes("Guest_")) return false;
    return true;
  };
  const isAllowedSpeaker = () => {
    let allowed = true;
    if (noneAllowedSpeakers.length > 0 && personTypes) {
      noneAllowedSpeakers.map((n) => {
        if (personTypes.includes(n)) {
          allowed = false;
        }
      });
    }
    return allowed;
  };

  const api = {
    speakers,
    agenda,
    ...props,
    activeSpeaker,
    activeAgenda: agenda.find((a) => a.active == true),
    speakers,

    isAllowedSpeaker,
    isAuthorizedSpeaker,
    hasRequestedTheFloor,
    requestTheFloor,
    unassignRequest,
  };
  return (
    <div style={{ background: settings?.background, display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "100%" }}>
      {/*       {activeSpeaker ? <ActiveSpeaker {...api} /> : null} */}
      <SpeakerControls {...{ ...api, hasRequestedTheFloor: hasRequestedTheFloor(), active: true }} />
    </div>
  );
};

const ActiveSpeaker = (props) => {
  const { template, activeSpeaker, settings } = props;
  const { fontFamily, fontSize, color, fontWeight } = settings;
  return (
    <List style={{ padding: 0 }}>
      <ListItem>
        <ListItemAvatar>
          <ChatAvatar
            {...combineProps([
              props,
              {
                primaryColor: "#00000029",
                secondaryColor: settings.color,
                target: activeSpeaker?.badgeNo,
              },
            ])}
          >
            <PersonRoundedIcon />
          </ChatAvatar>
        </ListItemAvatar>
        <ListItemText
          primary={
            <span style={{ fontFamily, fontSize, color, fontWeight }}>
              <EventLabel2 name="CurrentSpeaker" groupName="DigitalMeeting.SpeakerControl" />
            </span>
          }
          secondary={<span style={{ fontFamily, fontSize, color, fontWeight }}>{activeSpeaker ? activeSpeaker.name : ""}</span>}
        />
      </ListItem>
    </List>
  );
};

export function SpeakerControls(props) {
  const { hasRequestedTheFloor, active, speakers, isSpeakerActive, unassignRequest, activeAgenda, activeSpeaker, requestTheFloor, settings, orderId, template, preview } = props;
  const {
    allowPointOfOrder,
    borderRadius,
    allowRequestLineOfSpeaker,
    allowRequestTheFloor,
    fontFamily,
    fontSize,
    color,
    buttonBackground,
    fontWeight,
    background,
    overwriteTemplateButtonStyle,
    borderColor,
  } = settings;

  if (!hasRequestedTheFloor) {
    return (
      <div style={{ display: "flex", padding: "20px 0" }}>
        {allowPointOfOrder == true ? (
          <Button
            size="small"
            disabled={preview}
            style={
              template && !overwriteTemplateButtonStyle
                ? {
                  ...template.button,
                  margin: "5px 10px",
                  width: "90%",
                }
                : {
                  color,
                  borderRadius: 0,
                  margin: "5px 10px",
                  boxShadow: "none",
                  padding: template.button?.padding,
                  borderRadius,
                  fontFamily,
                  fontWeight,
                  fontSize,
                  border: `1px solid ${borderColor}`,
                  backgroundColor: buttonBackground,
                }
            }
            disabled={orderId == 1}
            onClick={() => requestTheFloor(3)}
            startIcon={<GavelIcon />}
          >
            <Tooltip title={<EventLabel2 name="PointOfOrder" groupName={eventLabelGroupsConstants.SPEAKER_CONTROL_LABEL_GROUP} />}>
              <span>
                <EventLabel2 name="PointOfOrder" groupName={eventLabelGroupsConstants.SPEAKER_CONTROL_LABEL_GROUP} />
              </span>
            </Tooltip>
          </Button>
        ) : null}
        {allowRequestTheFloor ? (
          <Button
            size="small"
            disabled={preview}
            style={
              template && !overwriteTemplateButtonStyle
                ? {
                  ...template.button,
                  margin: "5px 10px",
                  width: "90%",
                }
                : {
                  color,
                  borderRadius: 0,
                  margin: "5px 10px",
                  borderRadius,
                  padding: template.button?.padding,
                  boxShadow: "none",
                  fontFamily,
                  fontWeight,
                  fontSize,
                  border: `1px solid ${borderColor}`,
                  backgroundColor: buttonBackground,
                }
            }

            onClick={() => requestTheFloor(1)}
            disabled={orderId == 1}
            startIcon={<RecordVoiceOverIcon />}
          >
            <Tooltip title={<EventLabel2 name="RequestTheFloor" groupName={eventLabelGroupsConstants.SPEAKER_CONTROL_LABEL_GROUP} />}>
              <span>
                <EventLabel2 name="RequestTheFloor" groupName={eventLabelGroupsConstants.SPEAKER_CONTROL_LABEL_GROUP} />
              </span>
            </Tooltip>
          </Button>
        ) : null}
        {activeSpeaker && allowRequestLineOfSpeaker || preview ? (
          <Button
            size="small"
            variant="contained"
            disabled={orderId == 1}
            disabled={preview}
            style={
              template && !overwriteTemplateButtonStyle
                ? {
                  ...template.button,
                  margin: "5px 10px",
                  width: "90%",
                }
                : {
                  color,
                  borderRadius: 0,
                  margin: "5px 10px",
                  boxShadow: "none",
                  padding: template.button?.padding,
                  borderRadius,
                  fontFamily,
                  fontWeight,
                  fontSize,
                  border: `1px solid ${borderColor}`,
                  backgroundColor: buttonBackground,
                }
            }
            startIcon={<InsertCommentIcon />}
            edge="end"
            onClick={() => requestTheFloor(2, speakers.find((s) => s.active == true)?.interactionSpeakerId)}
          >
            <Tooltip title={<EventLabel2 name="RequestTheFloor" groupName={eventLabelGroupsConstants.SPEAKER_CONTROL_LABEL_GROUP} />}>
              <span>
                <EventLabel2 name="LineOfSpeaker" groupName={eventLabelGroupsConstants.SPEAKER_CONTROL_LABEL_GROUP} />
              </span>
            </Tooltip>
          </Button>
        ) : null}
      </div>
    );
  } else {
    return (
      <div style={{ padding: "20px 0" }}>
        <Button
          size="small"
          style={
            template && !overwriteTemplateButtonStyle
              ? {
                ...template.button,
                margin: "5px 10px",
                width: "90%",
              }
              : {
                color,
                borderRadius: 0,
                margin: "5px 10px",
                padding: template.button?.padding,
                borderRadius,
                boxShadow: "none",
                fontFamily,
                fontWeight,
                fontSize,
                border: `1px solid ${borderColor}`,
                backgroundColor: buttonBackground,
              }
          }
          disabled={isSpeakerActive || orderId == 1}
          onClick={unassignRequest}
          startIcon={<ClearIcon />}
        >
          <Tooltip title={<EventLabel2 name="UnassignRequest" groupName={eventLabelGroupsConstants.SPEAKER_CONTROL_LABEL_GROUP} />}>
            <EventLabel2 name="UnassignRequest" groupName={eventLabelGroupsConstants.SPEAKER_CONTROL_LABEL_GROUP} />
          </Tooltip>
        </Button>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    template: state.template.template ? state.template.template.content : null,
  };
}
export default connect(mapStateToProps)(SpeakerControl);
